import type { SkipItem } from './runOutcomeView'

/**
 * Список пропусков прогона. Общий на два места: итог прогона (`RunOutcome`) и
 * закрытый итог первой джобы цепочки (`PreviousRunNotice`) — вторая копия
 * разметки разъезжалась бы с первой при любой правке.
 *
 * Причины показываются ДОСЛОВНО серверными (см. `outcomeSkips`), поэтому здесь
 * никакого сопоставления текста нет.
 */
export const SkippedList = ({ items }: { items: SkipItem[] }) => (
  <ul className="space-y-1 text-xs text-muted-foreground">
    {items.map((item) => (
      <li key={item.key}>
        {item.label}: {item.reason}
      </li>
    ))}
  </ul>
)
